export default __webpack_public_path__ + "static/bridge-a4c7cdc959dab124a9d50bbde5f68f71.jpeg";